
(function(){

	$(window).scroll(function(){
		var scrollTop = $(window).scrollTop();
		$('.banner-bg05').css('transform', 'translate(0px,-'+(40/800)*scrollTop+'px)');
		$('.banner-bg04').css('transform', 'translate('+(350/800)*scrollTop+'px,-'+(200/800)*scrollTop+'px)');
		$('.banner-bg03').css('transform', 'translate(-810px,'+((400/800)*scrollTop-295)+'px)');
		$('.banner-bg02').css('transform', 'translate(0px,'+(680/800)*scrollTop+'px)');
		$('.banner-bg01').css('transform', 'translate(0px,'+(780/800)*scrollTop+'px)');
		$('.banner-bg01').css('top', '-'+(580/800)*scrollTop+'px');
	});

})()


/** WEBPACK FOOTER **
 ** ./src/js/compontents/animate.js
 **/